<template>
	<ProcessCreatePage>
		<Header :title="$t('new_comprehensive_accident_data').toString()">
			{{ $t('create_document_information') }}
		</Header>

		<div class="main">
			<AccidentDataForm ref="accident-data-form" @updateValue="model = $event" :show-injury="false" :show-record-policy="false" />
		</div>

		<Footer @continueButtonClick="continueButtonClick(false)" :is-skippable="false" :is-back-button="false" />
	</ProcessCreatePage>
</template>

<script>
import AppContainerMixin from '@/mixins/AppContainerMixin';
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import AccidentDataForm from '@/components/damagecases/forms/AccidentDataForm';
import Validate from '@/mixins/Validate';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'ProcessCreateComprehensiveAccident',
	components: { AccidentDataForm, ProcessCreatePage, Header, Footer },
	mixins: [AppContainerMixin, Validate],
	data() {
		return {
			model: {},
		};
	},
	methods: {
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next');
			} else if (this.validate()) {
				this.$store.commit('setProcessCreateComprehensiveAccident', this.model);
				this.$emit('next');
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
};
</script>
